import { IntlShape, defineMessages } from 'react-intl'
import * as yup from 'yup'

import { IChangeVehicleForm } from 'features/Trips/types'
import { isEmpty } from 'lodash'
import { CHANGE_VEHICLE_REASONS } from 'features/Trips/components/ChangeTripsVehicleModal'
import { CreateRouteServiceVehicleOverrideReasonCategory } from 'gql/generated/graphql'

const vehicleMessages = defineMessages({
  required: {
    id: 'trips.changeVehicle.vehicle.required',
    defaultMessage: 'The vehicle is required'
  }
})

const categoryMessages = defineMessages({
  requiredCategory: {
    id: 'trips.changeVehicle.category.required',
    defaultMessage: 'The category is required'
  },
  requiredSubcategory: {
    id: 'trips.changeVehicle.subcategory.required',
    defaultMessage: 'The subcategory is required'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IChangeVehicleForm> => {
  return yup.object().shape({
    vehicle: yup.object().shape({
      id: yup.string().required(intl.formatMessage(vehicleMessages.required)),
      name: yup.string().required(),
      externalID: yup.string().nullable()
    }),
    category: yup.string().required(intl.formatMessage(categoryMessages.requiredCategory)),
    comments: yup.string(),
    subcategory: yup
      .string()
      .test('required', intl.formatMessage(categoryMessages.requiredSubcategory), function (value) {
        const category = this.parent.category as CreateRouteServiceVehicleOverrideReasonCategory
        const hasSubcategories = CHANGE_VEHICLE_REASONS[category]?.subcategories.length > 0
        return hasSubcategories ? !isEmpty(value) : true
      })
  })
}
